/** @license Material-UI v3.0.0-alpha.0
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
export { default as exactProp } from './exactProp';
export { default as getDisplayName } from './getDisplayName';
export { default as ponyfillGlobal } from './ponyfillGlobal';



//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/utils/index.es.js
// module id = 45
// module chunks = 0